var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstancesHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9028 7.43357H3.09722C2.00757 7.43357 1.125 6.551 1.125 5.46135V3.48913C1.125 2.39948 2.00757 1.51691 3.09722 1.51691H16.9028C17.9924 1.51691 18.875 2.39948 18.875 3.48913V5.46135C18.875 6.551 17.9924 7.43357 16.9028 7.43357Z",
    fill: "url(#paint0_linear_68_1181)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9028 13.3503H3.09722C2.00757 13.3503 1.125 12.4677 1.125 11.378V9.40582C1.125 8.31616 2.00757 7.43359 3.09722 7.43359H16.9028C17.9924 7.43359 18.875 8.31616 18.875 9.40582V11.378C18.875 12.4677 17.9924 13.3503 16.9028 13.3503Z",
    fill: "url(#paint1_linear_68_1181)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9028 19.2669H3.09722C2.00757 19.2669 1.125 18.3843 1.125 17.2947V15.3224C1.125 14.2328 2.00757 13.3502 3.09722 13.3502H16.9028C17.9924 13.3502 18.875 14.2328 18.875 15.3224V17.2947C18.875 18.3843 17.9924 19.2669 16.9028 19.2669Z",
    fill: "url(#paint2_linear_68_1181)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9861 5.46136H5.06942C4.5241 5.46136 4.08331 5.01958 4.08331 4.47525C4.08331 3.93091 4.5241 3.48914 5.06942 3.48914H10.9861C11.5314 3.48914 11.9722 3.93091 11.9722 4.47525C11.9722 5.01958 11.5314 5.46136 10.9861 5.46136Z",
    fill: "#E0E7FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9306 5.46136C15.4752 5.46136 15.9167 5.01986 15.9167 4.47525C15.9167 3.93063 15.4752 3.48914 14.9306 3.48914C14.386 3.48914 13.9445 3.93063 13.9445 4.47525C13.9445 5.01986 14.386 5.46136 14.9306 5.46136Z",
    fill: "#E0E7FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9861 11.378H5.06942C4.5241 11.378 4.08331 10.9363 4.08331 10.3919C4.08331 9.8476 4.5241 9.40582 5.06942 9.40582H10.9861C11.5314 9.40582 11.9722 9.8476 11.9722 10.3919C11.9722 10.9363 11.5314 11.378 10.9861 11.378Z",
    fill: "#E0E7FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9306 11.378C15.4752 11.378 15.9167 10.9365 15.9167 10.3919C15.9167 9.84732 15.4752 9.40582 14.9306 9.40582C14.386 9.40582 13.9445 9.84732 13.9445 10.3919C13.9445 10.9365 14.386 11.378 14.9306 11.378Z",
    fill: "#E0E7FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9861 17.2947H5.06942C4.5241 17.2947 4.08331 16.8529 4.08331 16.3086C4.08331 15.7642 4.5241 15.3224 5.06942 15.3224H10.9861C11.5314 15.3224 11.9722 15.7642 11.9722 16.3086C11.9722 16.8529 11.5314 17.2947 10.9861 17.2947Z",
    fill: "#E0E7FC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9306 17.2947C15.4752 17.2947 15.9167 16.8532 15.9167 16.3086C15.9167 15.7639 15.4752 15.3224 14.9306 15.3224C14.386 15.3224 13.9445 15.7639 13.9445 16.3086C13.9445 16.8532 14.386 17.2947 14.9306 17.2947Z",
    fill: "#E0E7FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_68_1181",
    x1: 10,
    y1: 1.51691,
    x2: 10,
    y2: 7.43357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_68_1181",
    x1: 10,
    y1: 7.43359,
    x2: 10,
    y2: 13.3503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_68_1181",
    x1: 10,
    y1: 13.3502,
    x2: 10,
    y2: 19.2669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstancesHover);
export default __webpack_public_path__ + "static/media/instances-hover.60bb0e249f9765a32974bf0e2e1a695e.svg";
export { ForwardRef as ReactComponent };